import { c as _c } from "react/compiler-runtime";
import styled from 'styled-components';
import Typography from '../Typography/Typography';

// noinspection CssInvalidPropertyValue
export const StyledTypography = styled(Typography)`
    color: inherit;
    vertical-align: middle;
    text-wrap: nowrap;
    cursor: default;
`;
export const UppercaseLabelText = props => {
  const $ = _c(2);
  let t0;
  if ($[0] !== props) {
    t0 = <StyledTypography {...props} variant="uiType" size="3xs" modifier="SU" />;
    $[0] = props;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  return t0;
};
export const LabelText = props => {
  const $ = _c(2);
  let t0;
  if ($[0] !== props) {
    t0 = <StyledTypography {...props} variant="uiType" size="2xs" modifier="R" />;
    $[0] = props;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  return t0;
};